import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import { ExpiredPanel, DemoPageShell } from "@/components/demos/ExpiredPanel";

const inp = "w-full h-11 border border-slate-300 rounded-lg px-3 text-sm focus:outline-none focus:border-slate-900";

export function DemoExpiredPage() {
  usePageMeta("Demo expired", undefined, undefined, true);
  return <DemoPageShell testId="demo-expired-page"><ExpiredPanel /></DemoPageShell>;
}

export default function DemoLoginPage() {
  usePageMeta("Demo sign in", undefined, undefined, true);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const send = async () => { try { const { data } = await api.post("/api/demos/login/send-code", { email }); setSent(true); toast.success(data.message); } catch (e) { toast.error(errMsg(e)); } };
  const go = async () => { try { await api.post("/api/demos/login/verify", { email, code }); window.location.assign("/demo/app"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <DemoPageShell testId="demo-login-page">
      <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">Sign in to your demo</h1>
      <p className="text-slate-600 mt-2">We'll email you a one-time code.</p>
      <div className="mt-5 space-y-3"><input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email" className={inp} data-testid="dl-email" />
        {sent && <input value={code} onChange={e => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="6-digit code" inputMode="numeric" className={`${inp} tracking-[0.4em] text-center font-bold`} data-testid="dl-code" />}
        <button onClick={sent ? go : send} disabled={sent ? code.length !== 6 : !/\S+@\S+\.\S+/.test(email)} className="w-full h-12 rounded-full bg-slate-900 text-white font-bold disabled:opacity-40" data-testid="dl-submit">{sent ? "Sign in" : "Email me a code"}</button>
        <p className="text-xs text-slate-500">Set a password during activation? <Link to="/login" className="text-blue-700 font-semibold" data-testid="dl-password-login">Sign in with password</Link></p></div>
    </DemoPageShell>
  );
}
